module.exports = __webpack_public_path__ + "static/media/841NorthAvenueNW_2018-07-09_148.47a1571c.jpg";